import { Cancel, Search } from '@mui/icons-material'
import { Box, IconButton, InputAdornment, TextField } from '@mui/material'
import React from 'react'
import { useTheme } from '@mui/material/styles';

function SearchTxtField({ searchKeyWord, onSearch, placeholder, onBtnClick, variant, handleOnClear, width }) {
    const theme = useTheme();

     const handleKeyDown = (event) => {
        if (event.key === "Enter") {
            onBtnClick?.(); 
        }
    };

    return (
        <Box width={width ?? 300}>
            <TextField variant={variant ? variant : "outlined"} fullWidth
                value={searchKeyWord}
                onChange={onSearch && onSearch}     
                onKeyDown={handleKeyDown} 
                sx={{ "& .MuiInputBase-root": { height: 30, borderRadius: 10, fontSize: 13 } }}
                placeholder={placeholder}
                InputProps={{
                    endAdornment: (
                        <InputAdornment position={"end"} >
                            {searchKeyWord && ( // Show Clear button only if text exists
                                <IconButton onClick={handleOnClear} sx={{ color: "gray" }}>
                                    <Cancel fontSize="small" />
                                </IconButton>
                            )}
                            {onBtnClick && (
                                <IconButton onClick={onBtnClick} sx={{ color: theme?.palette?.custom?.btn }}>
                                    <Search />
                                </IconButton>
                            )}
                        </InputAdornment>
                    ),
                    style: { paddingLeft: 3, paddingRight: 3 },
                }}
            />
        </Box>
    )
}
export default SearchTxtField